export interface ProductLocalization {
  locale: string;
  termsPath: string;
  termsVersion: string;
  vendorName: string;
  vendorWebsite: string;
  productName: string;
  productPicturePath: string;
  privacyPolicyPath: string;
  productVariant: string | null;
}
